import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { initializeLogin, getAuthentication, sendCodeThroughSms, sendCodeThroughEmail, proceedAuthentication } from 'store/user/actions';
import { LoginComponent } from 'components';

const schema = {
  code: {
    presence: true,
    format: {
      pattern: '[0-9]{6}',
      message: 'Please enter a valid 6-digit code'
    }
  }
};

const TwoFactorAuthentication = props => {
  const { history } = props;
  const dispatch = useDispatch();

  const user = useSelector(store => store.user);

  const handleBack = () => {
    if (user.isSendCodeFailed) {
      dispatch(getAuthentication(user.loginData));
    } else {
      dispatch(initializeLogin());
      history.push('/');
    }
  };

  const handleSignIn = (event, values) => {
    event.preventDefault();
    dispatch(proceedAuthentication(values.code));
  };

  const handleSecurityCodeSms = () => {
    dispatch(sendCodeThroughSms(user.userName));
  };

  const handleSecurityCodeEmail = () => {
    dispatch(sendCodeThroughEmail(user.userName));
  };

  const getInputFields = () => [
    {
      name: 'code',
      label: "Security code",
      type: 'text',
      customStyles: { marginBottom: '16px' }
    },
    {
      name: 'smsLink',
      label: "Send a security code to my phone via SMS.",
      type: 'link',
      isClickable: true,
      action: handleSecurityCodeSms
    },
    {
      name: 'emailLink',
      label: "Send a security code to my email.",
      type: 'link',
      isClickable: true,
      action: handleSecurityCodeEmail
    },
    {
      name: 'codeLink',
      label: "Use generated code from Authenticator app.",
      type: 'link',
      isClickable: false,
      tooltip: "This option is only applicable if the user is registered with the Authenticator app. To register: login into core-UI->user profile->authenticator code->generate new code and scan with Authenticator app"
    }
  ];

  const getButtonGroup = () => [
    { title: 'Submit', isSubmit: true, action: (event, values) => handleSignIn(event, values) },
    { title: 'Go to Sign in', action: handleBack, isEnabled: true }
  ];

  return (
    <LoginComponent
      title={'Enter Security Code'}
      subTitle={'Please provide the required authorization details in the fields below.'}
      inputFields={getInputFields()}
      buttonGroup={getButtonGroup()}
      schema={schema}
    />
  );
};

TwoFactorAuthentication.propTypes = {
  history: PropTypes.object
};

export default withRouter(TwoFactorAuthentication);